module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("The American Way")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I affirm that life in the centuries that lie ahead must be based on positive and permanent values.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The value of love will always be stronger than the value of hate; since any nation or group of nations which employs hatred eventually is torn to pieces by hatred within itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The value of a belief in humanity and justice is always stronger in any land than the value of belief in force, because force at last turns inward and if that occurs each man or group of men is finally compelled to measure his strength against his own brother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The value of truth and sincerity is always stronger than the value of lies and cynicism. No process has yet been invented which can permanently separate men from their own hearts and consciences or prevent them from seeing the results of their own false ideas as time rolls by. You cannot make men believe that a way of life is good when it spreads poverty, misery, disease and death. Men cannot be everlastingly loyal unless they are free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We acclaim today the American Way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are determined to live in peace and to make that peace secure. We are determined to follow the paths of free peoples to a civilization worthy of free men.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("IV-15-1940")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c67e53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter01.vue
// module id = 78
// module chunks = 0